module.exports = __webpack_public_path__ + "static/media/7de50dd1-4a4e-47bf-bb5d-33bf1450649a.b46a7ecc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/7de50dd1-4a4e-47bf-bb5d-33bf1450649a.svg
// module id = 97
// module chunks = 0